import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UtilService {
    outerHeight(el: any) {
        const my_element = document.querySelector(el);
        const style = window.getComputedStyle(my_element);
        return my_element.getBoundingClientRect().height + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    }
}
